import _ from 'lodash';
import config from 'config';
import WebStoragePolyfill from '../../data-providers/webstorage-polyfill';

export default [
  '$window', '$state', '$stateParams', '$http', '$q', '$timeout', '$scope', 'StateTerritoryData', 'CartService', 'CampaignHistory',
  'CurrencyService', 'ErrorHandler', 'AuthService', 'UserDataService', 'UserService', 'AbandonedCartService',
  class StripeCheckoutController {
    constructor($window, $state, $params, $http, $q, $timeout, $scope, stateTerritoryData, cartService, campaignHistory,
      CurrencyService, errorHandler, authService, userDataService, userService, abandonedCart, webstorage = new WebStoragePolyfill()) {

      this._$window = $window;
      this._$state = $state;
      this._$http = $http;
      this._$q = $q;
      this._$timeout = $timeout;
      this._$window = $window;
      this._$scope = $scope;
      this._stateTerritoryData = stateTerritoryData;
      this._campaignHistory = campaignHistory;
      this._errorHandler = errorHandler;
      this._authService = authService;
      this._userDataService = userDataService;
      this._userService = userService;
      this._abandonedCart = abandonedCart;
      this._storage = webstorage;
      this._username = $params.pn;
      this._campaignSlug = $params.sl;
      this.popoverPath = 'assets/customer-ui/templates/cvv-help.html';

      this.customer = {};
      this.customer.apt = '';
      this.card = {};

      // init for masked inputs;
      this.customer.email = '';
      this.customer.mobile = '';
      this.customer.zip = '';
      this.password = '';
      this.passwordConfirm = '';
      this.card.cc_cvc = '';
      this.card.cc_num = '';
      this.validateEmailTimeout = null;
      this.validateEmailPromise = null;
      this.emailValid = true;
      this.emailError = false;
      this.paymentMethod = 'saved';

      this.monthRange = [];
      this.yearRange = [];

      this.processing = true;

      this.card.cc_expiry_mm = '';
      this.card.cc_expiry_yy = '';
      this.customer.state = '';

      this.currency = CurrencyService;
      this.cart = cartService;

      if (!this._username || !this._campaignSlug) {
        this.backToProductDetails(false);
      } else {
        this._initSelectOptions();
        this._initCheckout();
      }
    }

    completeOrder(isValid) {
      if (isValid && this._creditCardValid() && !this.completeOrderDisabled) {
        this.processing = true;
        this.completeOrderDisabled = true;
        if (this.validateEmailPromise) {
          this.validateEmailPromise
            .then(() => this.compleOrderHelper())
            .catch(() => {
              this.processing = false;
              this.completeOrderDisabled = false;
            })
            .finally(() => this.validateEmailPromise = null);
        } else {
          this.compleOrderHelper();
        }
      }
    }

    compleOrderHelper() {
      if (this.customer.country === 'US' && config.SmartyStreets.enabled) {
        this._$http({
            url: 'https://api.smartystreets.com/street-address',
            method: "GET",
            params: {
              'auth-id': config.SmartyStreets.ID,
              street: this.customer.address,
              city: this.customer.city,
              state: this.customer.state
            }
          })
          .then((res) => {
            if (res.data.length === 0) {
              this._errorHandler.throwError('Address Error', 'Your shipping address seems to be invalid. Please update it to be sure that we can deliver your purchase.');
              this.processing = false;
              this.completeOrderDisabled = false;
            } else {
              this.processPaymentHelper();
            }
          });
      } else {
        this.processPaymentHelper();
      }
    }

    processPaymentHelper() {
      this.cart.validateCouponBeforeCheckout()
        .then(() => this.processPayment())
        .catch(err => {
          this.showCouponInvalidModal = err && typeof err.valid !== 'undefined';
          this.processing = false;
          this.completeOrderDisabled = false;
        })
    }

    processPayment() {
      this.processing = true;
      this.showCouponInvalidModal = false;

      if (this.savedPaymentInfo && this.paymentMethod === 'saved') {
        this._savedTokenPayment();
      } else {
        this._newTokenPayment();
      }
    }

    _creditCardValid() {
      //this should not be needed, but just incase
      let returnVal = true;
      if ((!this.card.cc_num || !this.card.cc_expiry_yy || !this.card.cc_expiry_mm || !this.card.cc_cvc) && (!this.savedPaymentInfo && this.paymentMethod !== 'saved')) {
        this._errorHandler.throwError('Payment Info Error', 'Please correct missing payment info and try again.');
        returnVal = false;
      }
      return returnVal;
    }

    _newTokenPayment() {
      this.cart.createCCTokenCart(this.card, this.customer)
        .then(res => this.cart.processCCPayment(res.token, this.customer, this.card))
        .then(res => this.paymentProcessed(res))
        .catch(() => this.completeOrderDisabled = false)
        .finally(() => this.processing = false);
    }

    _savedTokenPayment() {
      this.cart.processSavedPayment(this.savedPaymentInfo.customer_id, this.customer)
        .then((res) => this.paymentProcessed(res))
        .catch(() => this.completeOrderDisabled = false)
        .finally(() => this.processing = false);
    }

    paymentProcessed(res) {
      if (this.rememberAddress) this._rememberAddress(this.customer);

      this._storage.removeLocalItem('order-credentials');
      this._storage.setLocalItem('order-credentials', `${res.order_num}:${this.customer.zip}`);
      this._$state.go('thank-you', {
        username: this._username,
        campaign: this._campaignSlug,
        // password: this.password
      });
    }

    validateEmail() {
      let deferred = this._$q.defer();
      this.validateEmailPromise = deferred.promise;
      this._$timeout.cancel(this.validateEmailTimeout);

      this.validateEmailTimeout = this._$timeout(() => {
        if (!this.customer.email || typeof this.customer.email == 'string' && this.customer.email.length == 0) {
          this._invalidEmail({}, deferred);
        } else {
          this._authService.verifyEmailAddress(this.customer.email)
            .then(() => this._validEmail(deferred))
            .catch(err => this._invalidEmail(err, deferred));
        }
      }, 500);
    }

    _validEmail(deferred) {
      this.emailValid = true;
      this.existingEmail = false;
      this.emailError = false;
      this._abandonedCart.trackAbandonedCart(this.customer.email);
      deferred.resolve();
    }

    _invalidEmail(err = {}, deferred) {
      if (err.data && err.data.message && err.data.message === "Email has already been registered.") {
        this.existingEmail = true;
        this.emailError = false;
        this._abandonedCart.trackAbandonedCart(this.customer.email);
        deferred.resolve();
      } else {
        this.existingEmail = false;
        this.emailError = true;
        deferred.reject();
      }
      this.emailValid = false;
      this.rememberAddress = false;
      this.password = '';
      this.passwordConfirm = '';
    }

    backToProductDetails(hasSlug) {
      if (hasSlug || (typeof this._username == 'string' && typeof this._campaignSlug == 'string')) {
        this._$window.location.href = `${this._username}/${this._campaignSlug}`;
      } else {
        let history = this._campaignHistory.getHistory();

        if (history.length) {
          this._$window.location.href = history[0].uri;
        } else {
          this._$window.location.href = '/';
        }
      }
    }

    stateChanged() {
      this.cart.setCountry(this.customer.country, this.customer.state);
    }

    countryChanged() {
      this.customer.state = '';
      this.customer.zip = '';
      this.cart.setCountry(this.customer.country);
      this.currency.setCountry(this.customer.country);
    }

    _initCheckout() {
      this.customer.country = this.usOnly ? 'US' : this.currency.info.country_code;

      let cartPromise = this.cart.init(this._username, this._campaignSlug);
      let loggedInCustomerPromise = this._initLoggedInCustomer();

      this._$q.all([cartPromise, loggedInCustomerPromise])
        .then(res => {
          if (this.cart.size() === 0) {
            this.backToProductDetails(true);
          } else {
            this._initCampaign(res[0]);
          }
        })
        .then(() => this._initCountryInfo())
        .finally(() => this.processing = false);

      this._$scope.$on('login:success', () => this._handleLoginLogout());
      this._$scope.$on('logout:success', () => this._handleLoginLogout());
    }


    _initCampaign(data) {
      this.campaign = data.campaign;

      if (this.campaign.cobrand_id) {
        this._$scope.$emit('partnership:showLogo', {
          pid: this.campaign.cobrand_id
        });
      }

      _.each(this.cart.contents(), cartProduct => {
        _.each(this.campaign.products, campaignProduct => {
          if (cartProduct.cpid === campaignProduct.id) {
            if (campaignProduct.product.us_only) this.usOnly = true;
            return false;
          }
        });
        if (this.usOnly) return false;
      });

      if (this.usOnly && this.customer.country !== 'US') {
        this.customer.country = 'US';
        this.customer.state = '';
        this.customer.zip = '';
      }
    }

    _initSelectOptions() {
      for (let i = 1; i < 13; i++) {
        this.monthRange.push({
          key: i,
          value: i
        });
      }

      let year = new Date().getFullYear();
      this.yearRange.push({
        key: year,
        value: year
      });
      for (let i = 1; i < 10; i++) {
        this.yearRange.push({
          key: year + i,
          value: year + i
        });
      }

      this.countries = this._stateTerritoryData.getCountries();
      this.states = this._stateTerritoryData.getExtendedStates();
      this.provinces = this._stateTerritoryData.getProvinces();
    }

    _initLoggedInCustomer() {
      return this._userDataService.getUserData()
        .then((customerInfo) => {
          if (customerInfo.user) customerInfo = customerInfo.user;

          let name = customerInfo.name.split(' ');
          this.existingEmail = true;
          this.emailValid = false;
          this.emailError = false;
          this.customerLoggedIn = true;
          this.customer.id = customerInfo.id;
          this.customer.email = customerInfo.email;
          this.customer.firstName = name[0];
          this.customer.lastName = name[name.length - 1];
          this.customer.name = customerInfo.name;
          this.customer.slug = customerInfo.user_info.public_name;
          this.customer.originalZip = customerInfo.user_info.shipping_details.zip || '00000';
          this.customer.address = customerInfo.user_info.shipping_details.street_1;
          this.customer.apt = customerInfo.user_info.shipping_details.street_2;
          this.customer.city = customerInfo.user_info.shipping_details.city;
          this.customer.zip = customerInfo.user_info.shipping_details.zip;
          this.customer.mobile = customerInfo.user_info.shipping_details.mobile;

          if (this.usOnly) {
            if (customerInfo.user_info.shipping_details.country === 'US') {
              this.customer.state = customerInfo.user_info.shipping_details.state;
            } else {
              this.customer.state = '';
              this.customer.zip = '';
            }
            this.customer.country = 'US';
          } else {
            this.customer.state = customerInfo.user_info.shipping_details.state;
            this.customer.country = customerInfo.user_info.shipping_details.country;
          }

          this._userService.getSavedPayment(this.customer.slug)
            .then(res => {
              this.paymentMethod = 'saved';
              this.savedPaymentInfo = res;
            })
            .catch(err => {
              this.savedPaymentInfo = null;
              this.paymentMethod = 'new';
            });
        })
        .catch(err => {
          this.customerLoggedIn = false;
          this.savedPaymentInfo = null;
          this.paymentMethod = 'new';
          if (this._$window.localStorage.getItem('address')) {
            this.customer = JSON.parse(this._$window.localStorage.getItem('address'));
          }
        });
    }

    _rememberAddress(customer) {
      // Unauthenticated:
      if (!this.customerLoggedIn) {
        customer.email = null;
        this._$window.localStorage.setItem('address', JSON.stringify(customer));
      }
      // Authenticated:
      else {
        this._userService.updateAddress(
            customer.slug, `${customer.firstName} ${customer.lastName}`, customer.address,
            customer.city, customer.state, customer.zip,
            customer.country, customer.mobile, customer.apt
          )
          .catch((res) => this._errorHandler.logError('Update Customer Address', 'Failed to update customer address on checkout.', res));
      }
    }

    _initCountryInfo() {
      let deferred = this._$q.defer(),
        cartPromise, currencyPromise;

      if (this.customer.address) {
        if (this.usOnly || this.customer.country === 'US') {
          if (this.customer.country === 'US') {
            cartPromise = this.cart.setCountry('US', this.customer.state)
          } else {
            this.customer.state = '';
            this.customer.zip = '';
            cartPromise = this.cart.setCountry('US')
          }
        } else {
          cartPromise = this.cart.setCountry(this.customer.country);
        }

        currencyPromise = this.currency.setCountry(this.customer.country);
      } else {
        currencyPromise = this.currency.init()
          .then(() => {
            if (this.usOnly || this.currency.info.country_code === 'US') {
              this.customer.country = 'US';
              this.cart.setCountry('US');
            } else {
              this.customer.country = this.currency.info.country_code;
              cartPromise = this.cart.setCountry(this.customer.country);
            }
          });
      }

      if (cartPromise) {
        this._$q.all([cartPromise, currencyPromise])
          .then(() => deferred.resolve())
          .catch(() => deferred.reject());
      } else {
        currencyPromise
          .then(() => deferred.resolve())
          .catch(() => deferred.reject());
      }

      return deferred.promise;
    }

    _handleLoginLogout() {
      this.processing = true;
      this._initLoggedInCustomer()
        .then(() => this._initCountryInfo())
        .finally(() => this.processing = false);
    }
  }
];


// WEBPACK FOOTER //
// ./source/client/pages/checkout/checkout.ctrl.js